/**
 * @example s_1=q_12:1|q_1:2&s_23=q_4:3
 */
import {URLData, URLScanData} from './data/URLData';

const SCAN_PREFIX: string = 's_';
const QUESTION_PREFIX: string = 'q_';

const SCAN_SEPARATOR: string = '&';
const SCAN_QUESTION_SEPARATOR: string = '=';
const QUESTION_SEPARATOR: string = '.';
const QUESTION_ANSWER_SEPARATOR: string = ':';

// tslint:disable-next-line no-unnecessary-class
export class Serializer {
    // tslint:disable-next-line function-name
    public static serialize(data: URLData): string {
        return Object.keys(data)
            .sort()
            .reduce((s: string, scanId: string, i: number): string => {
                const scanSeparator: string = i > 0 ? SCAN_SEPARATOR : '';
                const scanQuestions: string = Object.keys(data[scanId])
                    .sort()
                    .reduce(
                        (q: string, questionId: string, j: number): string => {
                            const questionSeparator: string =
                                j > 0 ? QUESTION_SEPARATOR : '';

                            return `${q}${questionSeparator}${QUESTION_PREFIX}${questionId}${QUESTION_ANSWER_SEPARATOR}${data[scanId][questionId]}`;
                        },
                        '',
                    );

                return `${s}${scanSeparator}${SCAN_PREFIX}${scanId}${SCAN_QUESTION_SEPARATOR}${scanQuestions}`;
            }, '');
    }

    /**
     * @example s_1=q_12:1|q_1:2&s_23=q_4:3
     */
    // tslint:disable-next-line function-name
    public static deserialize(serialized: string): URLData {
        return serialized
            .split(SCAN_SEPARATOR)
            .filter((part: string): boolean => part !== '')
            .reduce((data: URLData, rawScanQuestions: string): URLData => {
                // rawScanQuestions s_1=q_12:1|q_1:2

                const [scanKey, rawQuestions] = rawScanQuestions.split(
                    SCAN_QUESTION_SEPARATOR,
                );

                // scanKey s_1
                // rawQuestions q_12:1|q_1:2

                const questions: URLScanData = rawQuestions
                    .split(QUESTION_SEPARATOR)
                    .reduce(
                        (
                            scanData: URLScanData,
                            rawQuestionAnswer: string,
                        ): URLScanData => {
                            // rawQuestionAnswer q_12:1

                            const [
                                questionKey,
                                rawAnswer,
                            ] = rawQuestionAnswer.split(
                                QUESTION_ANSWER_SEPARATOR,
                            );

                            return {
                                ...scanData,
                                [questionKey.replace(
                                    QUESTION_PREFIX,
                                    '',
                                )]: parseInt(rawAnswer, 10),
                            };
                        },
                        {},
                    );

                return {
                    ...data,
                    [scanKey.replace(SCAN_PREFIX, '')]: questions,
                };
            }, {});
    }
}
